"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberWithCommas = exports.groupIntoPairs = exports.capitalizeFirstLetter = void 0;

var _lodash = require("lodash");

var groupIntoPairs = function groupIntoPairs(arr, f) {
  return Object.entries((0, _lodash.groupBy)(arr, f));
};

exports.groupIntoPairs = groupIntoPairs;

var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
}; // http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript


exports.capitalizeFirstLetter = capitalizeFirstLetter;

var numberWithCommas = function numberWithCommas(x) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

exports.numberWithCommas = numberWithCommas;